import { Link } from 'react-router-dom';
import { useForm, ValidationError } from '@formspree/react';
import { Card, CardContent, Button, Input } from '@/components/ui';
import { ArrowLeft, Send, CheckCircle } from 'lucide-react';

export function FeedbackPage() {
  const [state, handleSubmit] = useForm('xnjvqdaa');

  if (state.succeeded) {
    return (
      <div className="min-h-screen bg-[var(--color-bg)] p-4">
        <div className="mx-auto max-w-lg">
          <Card>
            <CardContent className="p-6 text-center">
              <CheckCircle className="mx-auto h-12 w-12 text-green-500" />
              <h2 className="mt-4 text-xl font-semibold">Thanks for your feedback!</h2>
              <p className="mt-2 text-[var(--color-muted)]">
                We appreciate you taking the time to reach out.
              </p>
              <Link to="/">
                <Button className="mt-6">Back to Home</Button>
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[var(--color-bg)] p-4">
      <div className="mx-auto max-w-lg">
        {/* Back link */}
        <Link
          to="/"
          className="mb-6 flex items-center gap-2 text-sm text-[var(--color-muted)] hover:text-[var(--color-text)]"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to home
        </Link>

        <h1 className="mb-6 text-2xl font-bold">Send Feedback</h1>

        <div className="space-y-4">
          {/* Intro blurb */}
          <Card>
            <CardContent className="p-4">
              <p className="text-[var(--color-muted)]">
                Want us to add your city? Find something wrong? Have a suggestion?
                Let me know here!
              </p>
            </CardContent>
          </Card>

          {/* Form */}
          <Card>
            <CardContent className="p-4">
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label htmlFor="name" className="mb-1 block text-sm font-medium">
                    Name
                  </label>
                  <Input
                    id="name"
                    type="text"
                    name="name"
                    placeholder="Your name (optional)"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="mb-1 block text-sm font-medium">
                    Email
                  </label>
                  <Input
                    id="email"
                    type="email"
                    name="email"
                    placeholder="your@email.com"
                    required
                  />
                  <ValidationError
                    prefix="Email"
                    field="email"
                    errors={state.errors}
                    className="mt-1 text-sm text-red-500"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="mb-1 block text-sm font-medium">
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows={5}
                    placeholder="What's on your mind?"
                    required
                    className="w-full rounded-lg border border-[var(--color-border)] bg-[var(--color-card)] px-3 py-2 text-sm placeholder:text-[var(--color-muted)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-primary"
                  />
                  <ValidationError
                    prefix="Message"
                    field="message"
                    errors={state.errors}
                    className="mt-1 text-sm text-red-500"
                  />
                </div>

                <Button
                  type="submit"
                  disabled={state.submitting}
                  className="w-full"
                >
                  <Send className="mr-2 h-4 w-4" />
                  {state.submitting ? 'Sending...' : 'Send Feedback'}
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
